// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__24xAM","header":"MergedInvoice_header__vzZlH"};